module.exports = __webpack_public_path__ + "static/media/Portrait-10020.168f8326.jpg";